import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { UserSimple } from '@app/user';

import { ShowHide } from '@app/core/animation/show-hide.animation';
import { Achievement } from '@app/core/model/library.model';

@Component({
    selector: 'app-byoc-episode-step-users-list-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss'],
    animations: [ShowHide],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ByocEpisodeStepUsersListUserComponent {
    @Input() user!: UserSimple;

    private achievementsPreviewCount = 6;

    get achievementsPreviews(): Achievement[] {
        if (this.user.achievements && this.user.achievements.length - this.achievementsPreviewCount - 1 > 0) {
            return this.user.achievements.slice(0, this.achievementsPreviewCount);
        } else {
            return this.user.achievements ?? [];
        }
    }

    get achievementsNotPreviewCount(): number {
        if (this.user.achievements && this.user.achievements.length - this.achievementsPreviewCount - 1 > 0) {
            return this.user.achievements.length - this.achievementsPreviewCount;
        }
        return 0;
    }
}
